module.exports = __webpack_public_path__ + "img/ingrid2.db21904.png";